import React from 'react';
import { CheckCircle2, CircleAlert, CloudOff, Loader2, RotateCcw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '@/components/ui/alert-dialog';
import { C } from '@/design-system/dna';
import { fmtDT } from './shared';

export function Checklist({ miss, sem, count }) {
  const total = sem ? 1 : Math.max(1, count * 3);
  const done = sem ? 1 : Math.max(0, total - miss.req.length);
  const ok = !miss.req.length;
  return (
    <div className="rounded-2xl border bg-white p-4" style={{ borderColor: ok ? '#1FA34A55' : '#F59E0B66' }} data-testid="dna-ficha-checklist">
      <div className="flex items-center gap-2">
        {ok ? <CheckCircle2 className="h-4 w-4 text-emerald-600" /> : <CircleAlert className="h-4 w-4 text-amber-600" />}
        <b className="text-[13px]" style={{ color: C.ink }}>{ok ? 'Pronta para registrar' : 'O que falta para concluir'}</b>
        <span className="ml-auto h-1.5 w-24 overflow-hidden rounded-full bg-[#EDE4F3]"><span className="block h-full rounded-full transition-[width] duration-300" style={{ width: `${Math.round((done / total) * 100)}%`, background: ok ? C.green : '#F59E0B' }} /></span>
      </div>
      {!!miss.req.length && <ul className="mt-2 space-y-0.5 text-[12px] text-amber-900" data-testid="dna-ficha-faltando">{miss.req.map((m) => <li key={m}>• {m}</li>)}</ul>}
      {!!miss.rec.length && <p className="mt-2 text-[11.5px]" style={{ color: C.muted }} data-testid="dna-ficha-recomendado">Recomendado: {miss.rec.join(' · ')}</p>}
    </div>
  );
}

export function SaveState({ saving, dirty, lastSaved, isDraft }) {
  const [I, txt, col] = saving ? [Loader2, 'Salvando…', C.muted] : dirty ? [CloudOff, 'Alterações não salvas', '#B45309'] : lastSaved ? [CheckCircle2, `${isDraft ? 'Rascunho salvo' : 'Salvo'} ${fmtDT(lastSaved)}`, C.green] : [null, '', C.muted];
  if (!txt) return <span className="mr-auto" />;
  return <span className="mr-auto inline-flex items-center gap-1.5 self-center text-[11.5px] font-semibold" style={{ color: col }} data-testid="dna-ficha-estado-salvamento">{I && <I className={`h-3.5 w-3.5 ${saving ? 'animate-spin' : ''}`} />}{txt}</span>;
}

export function RecoverNotice({ backup, onRecover, onDiscard }) {
  return (
    <div className="flex flex-wrap items-center gap-2 rounded-2xl bg-amber-50 px-4 py-3 text-[12.5px] text-amber-900" data-testid="dna-ficha-recuperar">
      <RotateCcw className="h-4 w-4" /> Há um preenchimento não salvo deste estudante ({fmtDT(backup.at)}).
      <span className="ml-auto flex gap-2"><Button size="sm" variant="outline" onClick={onDiscard} data-testid="dna-ficha-recuperar-descartar">Descartar</Button><Button size="sm" onClick={onRecover} data-testid="dna-ficha-recuperar-ok">Recuperar</Button></span>
    </div>
  );
}

export function CloseGuard({ open, onCancel, onDiscard, onSave }) {
  return (
    <AlertDialog open={open} onOpenChange={(o) => !o && onCancel()}>
      <AlertDialogContent className="w-[min(560px,94vw)] max-w-[560px]" data-testid="dna-ficha-sair-dialog">
        <AlertDialogHeader><AlertDialogTitle>Há alterações não salvas</AlertDialogTitle>
          <AlertDialogDescription>Salve como rascunho para continuar depois, ou descarte o que foi alterado desde o último salvamento.</AlertDialogDescription></AlertDialogHeader>
        <AlertDialogFooter className="flex-wrap gap-2">
          <AlertDialogCancel data-testid="dna-ficha-sair-continuar">Continuar editando</AlertDialogCancel>
          <Button variant="outline" onClick={onDiscard} data-testid="dna-ficha-sair-descartar">Descartar</Button>
          <AlertDialogAction onClick={onSave} data-testid="dna-ficha-sair-salvar">Salvar rascunho e fechar</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
